export class LoadGlobalSiteMasterList {
  static readonly type = '[Global] Load Site Master List';
}

export class ResetGlobalSiteMasterState {
  static readonly type = '[Global] Reset Site master state';
}

export class UpdateGlobalSiteNickname {
  static readonly type = '[Global] Update Site Nickname';

  constructor(
    public siteId: number,
    public siteNickname: string,
  ) {}
}
